import { List } from 'immutable';
import memoize from 'hs-lodash/memoize';
// @ts-expect-error module not typed
import { getTimestamp } from '../../common-message-format/operators/commonMessageFormatGetters';
import DateMessage from '../records/DateMessage';
// @ts-expect-error module not typed
import { shouldRenderDate } from './shouldRenderDate';
// @ts-expect-error module not typed
import { getMessageId } from '../../message-history/operators/getMessageId';
const buildDateMessage = memoize(DateMessage, ({
  id
}) => id);

/**
 * @description Strategically inserts date messages into a list
 * of history messages, optionally filtering out messages based on
 * the `messageFilter` function that can be passed in.
 */
export const insertDateMessages = (messageList, displayInitialMessageDate = true, messageFilter = () => true) => {
  let lastFilteredMessage = undefined;
  return messageList.reduce((messagesWithDates, message) => {
    if (messageFilter(message)) {
      if (shouldRenderDate(message, lastFilteredMessage, displayInitialMessageDate)) {
        const messageTimestamp = getTimestamp(message) || 0;
        messagesWithDates = messagesWithDates.push(buildDateMessage({
          id: `${getMessageId(message)}-date`,
          timestamp: messageTimestamp - 1 // make sure the date message always comes before the message that triggered it.
        }));
      }
      lastFilteredMessage = message;
    }
    return messagesWithDates.push(message);
  }, List());
};